module.exports = __webpack_public_path__ + "static/media/25.144690a0.svg";